module.exports = __webpack_public_path__ + "img/audio_muted.a259b7a1.svg";